import * as types from './mutation-types'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

export default {
  login: ({ commit, state }, authInfo) => {
    return client.auth({ data: { auth: { api: 'AuthService.adminLogin', input: authInfo } } })
      .then((data) => {
        if (data.auth.error) throw data.auth.error[0]
        if (data.auth.output) {
          localStorage.setItem('username', data.auth.output.user.login_id)
          localStorage.setItem('user_id', data.auth.output.user.id)
          localStorage.setItem('token', '1')
          commit(types.AUTH_LOGIN, data.auth.output.user)
          return data.auth.output.user
        }
      })
      .catch(err => { throw err })
  },
  logout: ({ commit }) => {
    return client.auth({ data: { auth: { api: 'AuthService.logout' } } })
      .then(() => {
        localStorage.removeItem('username')
        localStorage.removeItem('user_id')
        localStorage.removeItem('token')
        commit(types.AUTH_LOGOUT, null)
      })
  },
  initUser: ({ commit, dispatch }) => {
    return client.auth({ data: { auth: { api: 'AuthService.getLoginUser', input: {} } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('username', data.auth.output.name_zh || data.auth.output.name_en || data.auth.output.username)
          localStorage.setItem('user_id', data.auth.output.id)
          localStorage.setItem('token', '1')
          commit(types.AUTH_LOGIN, data.auth.output)
        }
        return data.auth.output
      })
      .catch((err) => { throw err })
  },
  clearStorage: ({ commit }) => {
    localStorage.removeItem('username')
    localStorage.removeItem('user_id')
    localStorage.removeItem('token')
    commit(types.AUTH_LOGOUT, null)
  },
  getAdminLoginValidations: ({ commit }) => {
    return client.auth({ data: { auth: { api: 'AuthService.getAdminLoginValidations', input: {} } } })
      .then((data) => {
        if (data.auth.output) {
          commit('VALIDATION', data.auth.output)
        }
      })
      .catch((err) => { throw err })
  },

  registerInit: ({ commit, state }, row) => {
    return client.postData({ data: { init: { api: 'M0001UserService.registerInit', input: row } } })
      .then((data) => {
        return data.init.output
      }).catch((err) => { throw err })
  },
  doRegister: ({ commit, state }, row) => {
    return client.postData({ data: { register: { api: 'M0001UserService.doRegister', input: row } } })
      .then((data) => {
        if (data.register.output.status === false) { throw new Error(data.register.output.message) } else {
          const output = data.register.output
          if (SysUtils.isEmpty(output.error)) {
            return output
          } else {
            return output.error
          }
        }
      }).catch((err) => { throw err })
  },
  doResetPassword: ({ commit, state }, row) => {
    return client.postData({ data: { reset: { api: 'M0001UserService.doResetPassword', input: row } } })
      .then((data) => {
        if (data.reset.output.status === false) { throw new Error(data.reset.output.message) } else {
          const output = data.reset.output
          if (SysUtils.isEmpty(output.error)) {
            return output
          } else {
            return output.error
          }
        }
      }).catch((err) => { throw err })
  }
}
